/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { makeStyles } from "@material-ui/core/styles";

export const useClasses = makeStyles((theme) => ({
    fields: {
        display: "flex",
        justifyContent: "space-between",
        margin: theme.spacing(4, 0, 2),
    },
    codeField: {},
    codeInputField: {
        height: theme.spacing(5.6),
        textAlign: "center",
    },
    buttonWrapper: {
        marginTop: theme.spacing(4),
    },
    loadingWrapper: {
        display: "flex",
        justifyContent: "center",
        marginTop: theme.spacing(4),
    },
}));
